document.addEventListener("DOMContentLoaded", function () {
  let lang = document.documentElement.lang;
  function checkElement() {
    const element = document.querySelector('.rc_widget__option__plans__dropdown.rc-selling-plans__dropdown');
    if (element) {
      clearInterval(interval);
      setTimeout(function() { //dodatkowe opóxnienie po interwale do znalezienia elementu - dla pewności że wszystko się załaduje

        //Synchronizacja dwustronna dropdown z wariantem i częstotliwością - wykonywana również przy starcie
        const variantDropdown = document.querySelector(".select__select");
        const frequencyDropdown = document.querySelector(".rc-selling-plans__dropdown");
        variantDropdown.value = variantDropdown.querySelector('option:first-child').value;
        const changeEvent = new Event('change', { bubbles: true });
        variantDropdown.dispatchEvent(changeEvent);
    
        variantDropdown.querySelectorAll("option").forEach((option, index) => {
          option.setAttribute("data-destination", frequencyDropdown.options[index].value);
        });
        
        function syncDropdowns() {
    
          const destinationValue = variantDropdown.options[variantDropdown.selectedIndex].getAttribute("data-destination");
          frequencyDropdown.value = destinationValue;
          const changeEvent = new Event('change', { bubbles: true });
          frequencyDropdown.dispatchEvent(changeEvent);
        }
    
        syncDropdowns();
    
        variantDropdown.addEventListener('change', function () {
          syncDropdowns();

           // Czyszczenie quantity input dla subskrypcji po zmianie wariantu
            const quantityInputSub = document.querySelector('.quantity-subscription .quantity__input');
            if (quantityInputSub) {
              quantityInputSub.value = 1;
          
              // Zaktualizuj również cenę po zmianie ilości
              timesPriceSub();
            }
        });

        // Klon i przeniesienie buttona add to cart oraz quantity input 
        function cloneAddToCart() {
          const elementToMove = document.querySelector('.product-form__buttons');
          const quantityToMove = document.querySelector('.product-form__quantity');
          const targetElementSubscription = document.querySelector('.rc_widget__option--subsave label');
          const targetElementOnetime = document.querySelector('.rc_widget__option--onetime label');
        
          if (elementToMove && targetElementSubscription && quantityToMove) {
            const clonedElementSub = elementToMove.cloneNode(true);
            clonedElementSub.classList.add('add-to-cart-subscription');

            const clonedQuantitySub = quantityToMove.cloneNode(true);
            clonedQuantitySub.classList.add('quantity-subscription');
        
            const newDiv = document.createElement('div');
            newDiv.classList.add('addToCart-wrapperSub');
            newDiv.appendChild(clonedElementSub);
            newDiv.appendChild(clonedQuantitySub);
            
        
            targetElementSubscription.insertAdjacentElement('afterend', newDiv);
          }
        
          if (elementToMove && targetElementOnetime && quantityToMove) {
            const clonedElementOne = elementToMove.cloneNode(true);
            clonedElementOne.classList.add('add-to-cart-onetime');
        
            const clonedQuantityOne = quantityToMove.cloneNode(true);
            clonedQuantityOne.classList.add('quantity-onetime');
        
            const newDiv = document.createElement('div');
            newDiv.classList.add('addToCart-wrapperOne');
            newDiv.appendChild(clonedElementOne);
            newDiv.appendChild(clonedQuantityOne);
        
            targetElementOnetime.insertAdjacentElement('afterend', newDiv);
            document.querySelector('.add-to-cart-onetime button').disabled = false;
          }
        }
        
        cloneAddToCart();

        // Wyzerowanie inputa z ilością oraz przywrócenie domyślnego wariantu sub po zmianie radio
        const radioButtons = document.querySelectorAll('.rc-radio input[type="radio"]');
        const quantityInputOne = document.querySelector('.quantity-onetime .quantity__input');
        const quantityInputSub = document.querySelector('.quantity-subscription .quantity__input');
        
        radioButtons.forEach(radioButton => {
          radioButton.addEventListener('change', () => {
            if (radioButton.checked) {
              if (quantityInputOne) quantityInputOne.value = 1;
              if (quantityInputSub) quantityInputSub.value = 1;
              cloneAndModifyPriceOne();
              cloneAndModifyPrice();
    
              variantDropdown.value = variantDropdown.querySelector('option:first-child').value;
    
              const changeEvent = new Event('change', { bubbles: true });
              variantDropdown.dispatchEvent(changeEvent);
  
            }
          });
        });

        function cloneProductText() {
          const subscriptionBuyInput = document.querySelector('.rc-radio.rc-option__subsave');
          const onetimeBuyInput = document.querySelector('.rc-radio.rc-option__onetime');
          const elementToMove = document.querySelector('.product-onetime');
          const elementToMoveTriple = document.querySelector('.product-sub');
          const elementToMoveOnlyOnetime = document.querySelector('.product-onetime-only');
          const targetElementSubscription = document.querySelector('.addToCart-wrapperSub');
          const targetElementOnetime = document.querySelector('.addToCart-wrapperOne');

         if (elementToMoveTriple && targetElementSubscription) {
            const clonedElementSub = elementToMove.cloneNode(true);
            const clonedElementSubTriple = elementToMoveTriple.cloneNode(true);
            clonedElementSub.classList.add('product-text-subscription');
            clonedElementSubTriple.classList.add('product-text-subscription-triple');
            targetElementSubscription.insertAdjacentElement('afterend', clonedElementSub);
            targetElementSubscription.insertAdjacentElement('afterend', clonedElementSubTriple);
          }
          
          if (elementToMove && targetElementOnetime) {
            const clonedElementOne = elementToMove.cloneNode(true);
            clonedElementOne.classList.add('product-text-onetime');
            targetElementOnetime.insertAdjacentElement('afterend', clonedElementOne);
          }
          
          if (elementToMoveOnlyOnetime && targetElementOnetime) {
            const clonedElementOnlyOne = elementToMoveOnlyOnetime.cloneNode(true);
            clonedElementOnlyOne.classList.add('product-text-onetime-only');
            targetElementOnetime.insertAdjacentElement('afterend', clonedElementOnlyOne);
          }
        }
  
        cloneProductText();


        //Usuwanie klasy dla product text w zależności od wariantu
        function checkProductText() {
          const selectedOptionIndex = variantDropdown.selectedIndex;
        
          const textOne = document.querySelector('.product-text-subscription');
          const textTriple = document.querySelector('.product-text-subscription-triple');
          const textOnlyOnetime = document.querySelector('.product-text-onetime-only');
        
          const subscriptionBuyInput = document.querySelector('.rc-radio.rc-option__subsave');
          const onetimeBuyInput = document.querySelector('.rc-radio.rc-option__onetime');
        
          if (textOne) textOne.classList.remove('active');
          if (textTriple) textTriple.classList.remove('active');
          if (textOnlyOnetime) textOnlyOnetime.classList.remove('active');
        
          if (subscriptionBuyInput && subscriptionBuyInput.classList.contains('rc-option--active')) {
            
            if (selectedOptionIndex === 0 && textOne) {
              textOne.classList.add('active');
            } else if (selectedOptionIndex === 1 && textTriple) {
              textTriple.classList.add('active');
            }
          } else if (onetimeBuyInput && onetimeBuyInput.classList.contains('rc-option--active')) {
            if (textOnlyOnetime) {
              textOnlyOnetime.classList.add('active');
              textOne.classList.remove('active');
            }
          }
        }

        variantDropdown.addEventListener('change', checkProductText);
        checkProductText();

        // Klonowanie elementu span z ceną i dodawanie go jako tekst w subskrypcji
        function cloneAndModifyPrice() {
        setTimeout(function() {
          const priceElement = document.querySelector('.rc_widget__price--subsave');
          const strikePrice = document.querySelector('.price__sale dd.price__compare .price-item.price-item--regular'); // pobieranie przekreślonej ceny
          const clonedPriceElement = document.querySelector('.price-span');
          const clonedPriceElementStrike = document.querySelector('.price-span-strike');
          const clonedPriceElementWithout = document.querySelector('.price-span-without');
          
          const selectedOptionIndex = variantDropdown.selectedIndex;
          let priceText;

          const priceButtonSubRegular = document.querySelector('.rc_widget__option--subsave .product-form__submit .price__regular .recharge-inner-most-price');
          const priceButtonSubSale = document.querySelector('.rc_widget__option--subsave .product-form__submit .price__sale .recharge-inner-most-price');
          
          const priceButtonSubSaleStrike = document.querySelector('.rc_widget__option--subsave .product-form__submit .price__sale .price-item--regular'); // pobieranie przekreślonej ceny z buttonu
          
            if (clonedPriceElement) {
              clonedPriceElement.remove();
            }
            if (clonedPriceElementStrike) {
              clonedPriceElementStrike.remove();
            }
            if (clonedPriceElementWithout) {
              clonedPriceElementWithout.remove();
            }
            
            if (priceElement) {
                let priceText;
                const jarTranslations = {
                    "pl": "zestaw",
                    "en": "set",
                };
            
                const jarText = jarTranslations[lang] || jarTranslations["en"];
            
                if (selectedOptionIndex === 0) {
                    const priceValue = parseFloat(priceElement.textContent.replace(/[^0-9,]/g, '').replace(',', '.'));
                    const priceValueStrike = parseFloat(strikePrice.textContent.replace(/[^0-9,]/g, '').replace(',', '.')); // liczenie przekreślonej ceny
                    priceText = `${priceValue.toFixed(2)} zł / ${jarText}`;
                    const discountPercentage = parseFloat(document.querySelector('.rc-option__discount').textContent.replace(/[^0-9,.]/g, ''));
                    const discountDecimal = discountPercentage / 100;
                    const discountAmount = priceValueStrike * discountDecimal;
                    const finalPrice = priceValueStrike - discountAmount;  //discountAmount or fixed price
                    const finalPriceOneRounded = parseFloat(priceValue.toFixed(2));
                    const finalPriceOneRoundedStrike = parseFloat(finalPrice.toFixed(2)); // zaokrąglanie przekreślonej ceny
                    priceTextStrike = `${finalPriceOneRoundedStrike} zł`;
                    priceButtonSubRegular.textContent = finalPriceOneRounded + ' zł';
                    priceButtonSubSale.textContent = finalPriceOneRounded + ' zł';
                    priceButtonSubRegular.setAttribute('data-base-price', finalPriceOneRounded);
                    priceButtonSubSale.setAttribute('data-base-price', finalPriceOneRounded);
                   
                    if (!isNaN(finalPriceOneRoundedStrike)) {
                      priceButtonSubSaleStrike.textContent = finalPriceOneRoundedStrike + ' zł';
                    } else {
                      priceButtonSubSaleStrike.textContent = '';
                    }
                }
                if (selectedOptionIndex === 1) {
                    const discountPercentage = parseFloat(document.querySelector('.rc-option__discount').textContent.replace(/[^0-9,.]/g, ''));
                    const discountDecimal = discountPercentage / 100;
                    const priceValue = parseFloat(document.querySelector('.no-js-hidden .price-item--regular').textContent.replace(/[^0-9,]/g, '').replace(',', '.')); //changed .no-js-hidden .price-item--regular
                    const priceValueStrike = parseFloat(strikePrice.textContent.replace(/[^0-9,]/g, '').replace(',', '.')); //liczenie przekreślonej ceny
                    const discountAmount = priceValue * discountDecimal;
                    const discountAmountStrike = priceValueStrike * discountDecimal; //liczenie rabatu przekreślonej ceny
                    const finalPrice = priceValue - discountAmount;
                    const finalPriceStrike = priceValueStrike - discountAmount; // finalna przekreślona cena po rabacie -discountAmount or fixed price
                    const finalPriceRounded = parseFloat(finalPrice.toFixed(2));
                    const finalPriceRoundedStrike = parseFloat(finalPriceStrike.toFixed(2));
                    const dividedPrice = (finalPrice / 3).toFixed(2);
                    const dividedPriceStrike = (finalPriceRoundedStrike / 3).toFixed(2);
                    priceText = `${dividedPrice} zł / ${jarText}`;
                    priceTextStrike = `${dividedPriceStrike} zł`;
                    priceButtonSubRegular.textContent = finalPriceRounded + ' zł';
                    priceButtonSubSale.textContent = finalPriceRounded + ' zł';
                    priceButtonSubRegular.setAttribute('data-base-price', finalPriceRounded);
                    priceButtonSubSale.setAttribute('data-base-price', finalPriceRounded);
                   
                    if (!isNaN(finalPriceRoundedStrike)) {
                      priceButtonSubSaleStrike.textContent = finalPriceRoundedStrike + ' zł';
                    } else {
                      priceButtonSubSaleStrike.textContent = '';
                    }
                }
            
                const newPriceElement = document.createElement('span');
                const newPriceElementStrike = document.createElement('span');
                
                newPriceElementStrike.classList.add('price-span-strike');
                newPriceElementStrike.textContent = priceTextStrike;
                if (newPriceElementStrike.innerHTML != 'NaN zł') {
                  newPriceElement.classList.add('price-span');
                } else {
                  newPriceElement.classList.add('price-span-without');
                }
                newPriceElement.textContent = priceText;
            
                priceElement.insertAdjacentElement('afterend', newPriceElement);

                if (newPriceElementStrike.innerHTML != 'NaN zł') {
                  newPriceElement.insertAdjacentElement('beforebegin', newPriceElementStrike);
                }
                
            }
          }, 1000);
        }
        variantDropdown.addEventListener('change', cloneAndModifyPrice);
        cloneAndModifyPrice();

        // Klonowanie elementu span z ceną i dodawanie go jako tekst w onetime
        function cloneAndModifyPriceOne() {
        setTimeout(() => {
          const priceElement = document.querySelector('.rc_widget__price--onetime');
          const radioVariant = document.querySelector('.rc_widget__option--subsave');
          const strikePriceOne = document.querySelector('.price__sale dd.price__compare .price-item.price-item--regular'); // pobieranie przekreślonej ceny
          const priceValueStrikeOne = parseFloat(strikePriceOne.textContent.replace(/[^0-9,]/g, '').replace(',', '.'));
          const clonedPriceElement = document.querySelector('.price-span-one'); 
          const clonedPriceElementWithout = document.querySelector('.price-span-one-without'); 
             
                if (clonedPriceElement) {
                  clonedPriceElement.remove();
                }
                if (clonedPriceElementWithout) {
                  clonedPriceElementWithout.remove();
                }
                if (priceElement) {
                  const priceValue = parseFloat(priceElement.textContent.replace(/[^0-9,]/g, '').replace(',', '.'));
                  const jarTranslations3 = {
                      "pl": "zestaw",
                      "en": "set",
                  };
              
                  const jarText3 = jarTranslations3[lang] || jarTranslations3["en"];
              
                  const priceText = `${priceValue.toFixed(2)} zł / ${jarText3}`;
                  const clonedPriceElementStrikeOne = document.querySelector('.price-span-one-strike');
                  const newPriceElement = document.createElement('span');
                  const newPriceElementStrike = document.createElement('span')
                  
                  newPriceElementStrike.classList.add('price-span-one-strike');
                  newPriceElementStrike.textContent = priceValueStrikeOne + ' zł';
                  if (newPriceElementStrike.innerHTML != 'NaN zł') {
                    newPriceElement.classList.add('price-span-one');
                  } else {
                    newPriceElement.classList.add('price-span-one-without');
                  }
                  newPriceElement.textContent = priceText;
                  priceElement.insertAdjacentElement('afterend', newPriceElement);
                  if (clonedPriceElementStrikeOne) {
                    clonedPriceElementStrikeOne.remove();
                  }
                  
                  if (newPriceElementStrike.innerHTML != 'NaN zł') {
                    newPriceElement.insertAdjacentElement('beforebegin', newPriceElementStrike);
                  }
              }
            
          }, 300);
        }
        cloneAndModifyPriceOne()

        // Obsługa mnożenia ceny przez ilość ONETIME
        function timesPrice() {
          const priceElement = document.querySelector('.rc_widget__price--onetime');
          const quantityInput = document.querySelector('.quantity-onetime .quantity__input');
          const priceButton = document.querySelector('.rc_widget__option--onetime .product-form__submit .recharge-inner-most-price');
        
          if (!priceElement || !quantityInput || !priceButton) return;
        
          const priceValue = parseFloat(priceElement.textContent.replace(/[^0-9,]/g, '').replace(',', '.'));
          const quantity = parseInt(quantityInput.value);
        
          if (isNaN(priceValue) || isNaN(quantity)) return;
        
          const final = (priceValue * quantity).toFixed(2);
          priceButton.textContent = `${final} zł`;
        }
        
        const quantityInputOnetime = document.querySelector('.quantity-onetime .quantity__input');
        if (quantityInputOnetime) {
          quantityInputOnetime.addEventListener('change', timesPrice);
          timesPrice();
        }

        // Obsługa mnożenia ceny przez ilość SUBSCRIPTION
        function timesPriceSub() {
          const quantityInput = document.querySelector('.quantity-subscription .quantity__input');
          const priceButton = document.querySelector('.rc_widget__option--subsave .product-form__submit .recharge-inner-most-price');
        
          if (!quantityInput || !priceButton) return;
        
          const basePriceAttr = priceButton.getAttribute('data-base-price');
          const basePrice = parseFloat(basePriceAttr);
          const quantity = parseInt(quantityInput.value);
        
          if (isNaN(basePrice) || isNaN(quantity)) return;
        
          const final = (basePrice * quantity).toFixed(2);
          priceButton.textContent = `${final} zł`;
        }
        
        const quantityInputSubscription = document.querySelector('.quantity-subscription .quantity__input');
        if (quantityInputSubscription) {
          quantityInputSubscription.addEventListener('change', timesPriceSub);
          timesPriceSub();
        }
        
        //Dodanie custom dropdown dla wariantów

        function addCustomVariantDropdown() {
          const container = document.querySelector('.rc-option__subsave .rc_widget__option__label');
          const options = variantDropdown.querySelectorAll('option');
        
          const subDiscount = document.querySelector('.sub-discount');
          const subDiscount1 = document.querySelector('.sub-discount1');
          const subDiscountValue = subDiscount?.dataset.discount || '';
          const subDiscountValue1 = subDiscount1?.dataset.discount || '';
        
          const oneMonthText = {
            "pl": "co 1 msc",
            "en": "every 1 month",
          };
          const threeMonthsText = {
            "pl": "co 3 msc",
            "en": "every 3 months",
          };
        
          const textOneMonth = oneMonthText[lang] || oneMonthText["en"];
          const textThreeMonths = threeMonthsText[lang] || threeMonthsText["en"];
        
          const wrapper = document.createElement('div');
          wrapper.classList.add('custom-variant-dropdown');
        
          const toggle = document.createElement('div');
          toggle.classList.add('variant-dropdown-toggle');
        
          const list = document.createElement('ul');
          list.classList.add('variant-dropdown-list');
        
          const variantTexts = [
            `${options[0].textContent} ${textOneMonth}`,
            `${options[1].textContent} ${textThreeMonths}`
          ];
        
          const discountValues = [subDiscountValue1, subDiscountValue];
        
          // Domyślny pierwszy wybór
          toggle.innerHTML = `
            <span class="variant-label">${variantTexts[0]}</span>
            <span class="variant-discount">${discountValues[0]}</span>
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.346191" width="20" height="20" rx="10" fill="#244545"/>
            <path d="M5.5 8.84619L10 11.8462L14.5 8.84619" stroke="white" stroke-width="2" stroke-linejoin="round"/>
            </svg>
          `;
        
          // Synchronizacja z pierwszym wariantem na starcie
          variantDropdown.value = options[0].value;
          const initialChange = new Event('change', { bubbles: true });
          variantDropdown.dispatchEvent(initialChange);
        
          variantTexts.forEach((text, index) => {
            const li = document.createElement('li');
            li.classList.add('variant-dropdown-item');
            li.innerHTML = `
              <span class="variant-label">${text}</span>
              <span class="variant-discount">${discountValues[index]}</span>
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="0.346191" width="20" height="20" rx="10" fill="#244545"/>
              <path d="M5.5 8.84619L10 11.8462L14.5 8.84619" stroke="white" stroke-width="2" stroke-linejoin="round"/>
              </svg>
            `;
        
            li.addEventListener('click', () => {
              toggle.innerHTML = `
                <span class="variant-label">${text}</span>
                <span class="variant-discount">${discountValues[index]}</span>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.346191" width="20" height="20" rx="10" fill="#244545"/>
                <path d="M5.5 8.84619L10 11.8462L14.5 8.84619" stroke="white" stroke-width="2" stroke-linejoin="round"/>
                </svg>
              `;
        
              list.classList.remove('open');
              toggle.classList.remove('open');
        
              variantDropdown.value = options[index].value;
              const changeEvent = new Event('change', { bubbles: true });
              variantDropdown.dispatchEvent(changeEvent);
            });
        
            list.appendChild(li);
          });
        
          toggle.addEventListener('click', () => {
            list.classList.toggle('open');
            toggle.classList.toggle('open');
          });
        
          wrapper.appendChild(toggle);
          wrapper.appendChild(list);
          container.insertAdjacentElement('afterend', wrapper);
        }
        
        addCustomVariantDropdown();
  
        //Przywracanie domyślnego wariantu (dropdown) po zminaie na onetime
        const customDropdownToggle = document.querySelector('.variant-dropdown-toggle');
        const variantListItems = document.querySelectorAll('.variant-dropdown-item');
        
        radioButtons.forEach(radioButton => {
          radioButton.addEventListener('change', () => {
            if (radioButton.checked) {
              // Przywrócenie pierwszego wariantu
              const firstLabel = variantListItems[0].querySelector('.variant-label').innerHTML;
              const firstDiscount = variantListItems[0].querySelector('.variant-discount').innerHTML;
        
              // Aktualizacja toggle (tekst dropdownu)
              customDropdownToggle.innerHTML = `
                <span class="variant-label">${firstLabel}</span>
                <span class="variant-discount">${firstDiscount}</span>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.346191" width="20" height="20" rx="10" fill="#244545"/>
                <path d="M5.5 8.84619L10 11.8462L14.5 8.84619" stroke="white" stroke-width="2" stroke-linejoin="round"/>
                </svg>
              `;
        
              // Aktualizacja selecta (ukrytego)
              variantDropdown.value = variantDropdown.options[0].value;
              const changeEvent = new Event('change', { bubbles: true });
              variantDropdown.dispatchEvent(changeEvent);
            }
          });
        });

        //Klonowanie tekstów subskrypcji
          const subscriptionElements = document.querySelectorAll('.product__subscription');
          const targetElementSub = document.querySelector('.rc-option__subsave .rc_widget__option__label');
          
          if (subscriptionElements.length > 0 && targetElementSub) {
            const newDivSub = document.createElement('div');
            newDivSub.classList.add('subscription-elements-wrapper');
            
            subscriptionElements.forEach(element => {
              const clonedElementSub = element.cloneNode(true);
              clonedElementSub.classList.add('copy');
              newDivSub.appendChild(clonedElementSub);
            });
        
            targetElementSub.insertAdjacentElement('afterend', newDivSub);
          }
  
        //Klonowanie tekstów onetime
          const onetimeElements = document.querySelectorAll('.product__subscription--single-purchase');
          const targetElementOne = document.querySelector('.rc-option__onetime .rc_widget__option__label');

          const oneDiscount = document.querySelector('.one-discount');
          const oneDiscountValue = oneDiscount.dataset.discount;
          const newDiscountOne = document.createElement('span');
          newDiscountOne.classList.add('variant-discount');
          newDiscountOne.innerHTML = oneDiscountValue;
          
          if (onetimeElements.length > 0 && targetElementOne) {
            const newDivOne = document.createElement('div');
            newDivOne.classList.add('onetime-elements-wrapper');
            
            onetimeElements.forEach(element => {
              const clonedElementOne = element.cloneNode(true);
              clonedElementOne.classList.add('copy');
              newDivOne.appendChild(clonedElementOne);
            });
        
            targetElementOne.insertAdjacentElement('afterend', newDivOne);
            newDivOne.appendChild(newDiscountOne);
          }
        
        //Tumaczenie tekstu subskrypcja i zakup jednorazowy
        function updateTextsForEnglish() {
  
        if (lang === 'en') {
            const subscriptionTextElement = document.querySelector('.rc-option__subsave .rc-option__text');
            if (subscriptionTextElement) {
                subscriptionTextElement.textContent = 'SUBSCRIPTION';
            }
    
            const oneTimeTextElement = document.querySelector('.rc-option__onetime .rc-option__text');
            if (oneTimeTextElement) {
                oneTimeTextElement.textContent = 'ONETIME';
            }
          }
        }
        
        updateTextsForEnglish();
      
      }, 500);
    }
  }
  const interval = setInterval(checkElement, 500);
});